import { ExtendDirection } from '@/modules/common';
import { DeleteTeamMemberChangeRequestPeriod } from '@/types/generated/common';

export const mapExtendDirectionToPeriod = (
  direction: ExtendDirection
): DeleteTeamMemberChangeRequestPeriod => {
  switch (direction) {
    case ExtendDirection.Previous:
      return DeleteTeamMemberChangeRequestPeriod.Previous;
    case ExtendDirection.Next:
      return DeleteTeamMemberChangeRequestPeriod.Next;
    default:
      return DeleteTeamMemberChangeRequestPeriod.Previous;
  }
};
